export default "__VITE_ASSET__Bk343Zuo__"